<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 14 12"
    :fill="color"
    xmlns="http://www.w3.org/2000/svg"
    :style="{ color }"
  >
    <g id="PhotoSVG" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
      <g
        id="W---Coversation---Add-image"
        transform="translate(-595.000000, -748.000000)"
        :fill="color"
        fill-rule="nonzero"
      >
        <g id="Group" transform="translate(585.000000, 695.000000)">
          <g id="Group-7" transform="translate(0.000000, 42.000000)">
            <g id="" transform="translate(5.000000, 5.000000)">
              <path
                d="M18.125,18 C18.375,18 18.5833333,17.9166667 18.75,17.75 C18.9166667,17.5833333 19,17.375 19,17.125 L19,17.125 L19,6.875 C19,6.625 18.9166667,6.41666667 18.75,6.25 C18.5833333,6.08333333 18.375,6 18.125,6 L18.125,6 L5.875,6 C5.625,6 5.41666667,6.08333333 5.25,6.25 C5.08333333,6.41666667 5,6.625 5,6.875 L5,6.875 L5,17.125 C5,17.375 5.08333333,17.5833333 5.25,17.75 C5.41666667,17.9166667 5.625,18 5.875,18 L5.875,18 L18.125,18 Z M18,16 L14.90625,12.4926471 C14.8020833,12.3602941 14.6666667,12.2941176 14.5,12.2941176 C14.375,12.2941176 14.2395833,12.3492647 14.09375,12.4595588 L14.09375,12.4595588 L13.53125,12.9889706 C13.3854167,13.0992647 13.2604167,13.1544118 13.15625,13.1544118 C13.0520833,13.1544118 12.9375,13.1102941 12.8125,13.0220588 L12.8125,13.0220588 L12.6875,12.8897059 L11,10.9375 C10.875,10.7830882 10.6979167,10.7058824 10.46875,10.7058824 C10.28125,10.7058824 10.1041667,10.7941176 9.9375,10.9705882 L9.9375,10.9705882 L6,16 L6,7.39705882 C6.04166667,7.13235294 6.17708333,7 6.40625,7 L6.40625,7 L17.59375,7 C17.8645833,7 18,7.13235294 18,7.39705882 L18,7.39705882 L18,16 Z M15.5,11 C15.9166667,11 16.2708333,10.8541667 16.5625,10.5625 C16.8541667,10.2708333 17,9.91666667 17,9.5 C17,9.08333333 16.8541667,8.72916667 16.5625,8.4375 C16.2708333,8.14583333 15.9166667,8 15.5,8 C15.0833333,8 14.7291667,8.14583333 14.4375,8.4375 C14.1458333,8.72916667 14,9.08333333 14,9.5 C14,9.91666667 14.1458333,10.2708333 14.4375,10.5625 C14.7291667,10.8541667 15.0833333,11 15.5,11 Z"
              ></path>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
</template>

<script>
import VueTypes from 'vue-types';

export default {
  name: 'PhotoSVG',
  props: {
    size: VueTypes.number.isRequired,
    color: VueTypes.string.isRequired,
  },
};
</script>

<style></style>
